<template>
    <div class="space-details-block">
        <div class="btn-group admin-button-group btn-group-justified" role="group">
            <disable-space-modal :space="space"/>
            <enable-space-modal :space="space"/>
            <remove-listing-modal :space="space"/>

            <a v-if="space.enabled" class="btn btn-default" @click.prevent="$bus.$emit('showDisableModal')">Disable</a>
            <a v-else-if="!space.follow_up" class="btn btn-default" @click.prevent="$bus.$emit('showEnableModal')">Enable</a>

            <a v-if="space.enabled && !space.follow_up" class="btn btn-default" :class="{ disabled: !space.enabled && space.follow_up }" :href="`${ getViewData('env.ADMIN_SUBDOMAIN') }${ $laroute.route('account.landlord.listings.edit', { id: this.space.id }) }`">Edit</a>
        </div>
        <div class="btn-group admin-button-group btn-group-justified" role="group">
            <a v-if="space.enabled && !space.follow_up" class="btn btn-default" :class="{ disabled: !space.enabled }" @click.prevent="$bus.$emit('showRemoveListingModal')">Remove Listing</a>
            <a class="btn btn-default" :href="`${ getViewData('env.ADMIN_SUBDOMAIN') }${ $laroute.route('hatchly.spaces.info', { id: space.id }) }`">Info</a>
            <a class="btn btn-default" :href="`${ getViewData('env.ADMIN_SUBDOMAIN') }${ $laroute.route('hatchly.users.edit', { userId: landlordId }) }`">Space owner</a>
        </div>
    </div>
</template>

<style lang="less" scoped rel="stylesheet/less">
    @import "~assets/less/variables.less";

    .space-details-block {
        margin: -10px 0 10px;
        @media (min-width: @screen-sm-min) {
            margin: -20px 0 20px;
        }
        .admin-button-group {
            &:first-child {
                margin-bottom: 10px;
            }
        }
        .btn {
            overflow: hidden;
        }
    }
</style>

<script>
    import { getViewData } from '../../modules/view-data';

    export default {
        name: 'admin-bar',

        props: ['space', 'landlordId'],

        data() {
            return {
                getViewData,
            };
        },
    }
</script>
